import { render, staticRenderFns } from "./TileProductThroughput.vue?vue&type=template&id=2086cb92"
import script from "./TileProductThroughput.vue?vue&type=script&lang=js"
export * from "./TileProductThroughput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports